var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9258 16.1893C32.9258 23.4265 27.9859 29.5259 21.2501 31.3864C19.8746 31.7663 18.4243 31.9695 16.9258 31.9695C15.4273 31.9695 13.9769 31.7663 12.6015 31.3864C5.86571 29.5259 0.925781 23.4265 0.925781 16.1893C0.925781 7.47409 8.08923 0.409058 16.9258 0.409058C25.7623 0.409058 32.9258 7.47409 32.9258 16.1893Z",
    fill: "#E82327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2501 31.3864C19.8746 31.7663 18.4243 31.9695 16.9258 31.9695C15.4273 31.9695 13.9769 31.7663 12.6015 31.3864L16.5895 36.2507C16.7626 36.4618 17.089 36.4618 17.262 36.2507L21.2501 31.3864Z",
    fill: "#E82327"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.92578,
    y: 3.00916,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5767 9.78174H14.2743C14.056 9.78174 13.876 9.95954 13.876 10.1801V12.2236H14.6704V10.5762H19.1784V12.2214H19.9728V10.1801C19.9751 9.96179 19.795 9.78174 19.5767 9.78174Z",
    fill: "#515E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1274 12.3744V21.8742C24.1274 22.0722 23.9654 22.2365 23.7651 22.2365H10.086C9.88568 22.2365 9.72363 22.0722 9.72363 21.8742V12.3744C9.72363 12.1764 9.88568 12.0121 10.086 12.0121H23.7673C23.9654 12.0143 24.1274 12.1764 24.1274 12.3744Z",
    fill: "#B47B52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1274 12.3744V15.2394H9.72363V12.3744C9.72363 12.1764 9.88568 12.0121 10.086 12.0121H23.7673C23.9654 12.0143 24.1274 12.1764 24.1274 12.3744Z",
    fill: "#8E5C3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2489 16.0181H15.6022C15.5144 16.0181 15.4401 15.9461 15.4401 15.8561V14.6228C15.4401 14.535 15.5122 14.4607 15.6022 14.4607H18.2489C18.3367 14.4607 18.4109 14.5327 18.4109 14.6228V15.8561C18.4109 15.9461 18.3389 16.0181 18.2489 16.0181Z",
    fill: "#515E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAdd);
export default __webpack_public_path__ + "static/media/OfficeAdd.50bec3ef9a1c538ebd6d395ef8988c94.svg";
export { ForwardRef as ReactComponent };